import { render, staticRenderFns } from "./importar-extrato.vue?vue&type=template&id=fa341276&"
import script from "./importar-extrato.vue?vue&type=script&lang=js&"
export * from "./importar-extrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports